import React, { useEffect, useState, useCallback } from 'react';
import $i18n from '@/i18n';
import {  Loading } from '@b-design/fusion';
import Requests from '@/services/request';
import empty from '@/assets/overview/empty.svg';
import Header from './component/header';
import AppList from './component/appList';
import CreateDrawer from './component/setUpChannel';
import Button from '@/components/Button';
import { getQueryStringArgs } from '@/utils/url-parse';
import store from '@/store';
import './index.less';

type item = Record<
  | 'createName'
  | 'createUid'
  | 'description'
  | 'gmtCreate'
  | 'gmtModified'
  | 'icon'
  | 'iconPublicUrl'
  | 'innerCode'
  | 'inuseStatus'
  | 'modifiedName'
  | 'modifiedUid'
  | 'name'
  | 'outerCode'
  | 'spaceId'
  | 'status'
  | 'statusDesc',
  string
>;

interface ChannelDataSource {
  list: item[];
  total: number;
}
export interface items extends item {
  caller: any[];
}

const ChannelSetting: React.FC = () => {
  const { spaceId } = getQueryStringArgs();
  const [channelData, setChannelData] = useState<ChannelDataSource>({ list: [], total: 0 });
  const [loading, setLoading] = useState(true);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [spaceRoleState] = store.useModel('spaceRole');

  // 分页参数
  const [paginationValue, setPaginationValue] = useState<
    Record<'currentPage' | 'pageSize', number>
  >({
    currentPage: 1,
    pageSize: 12,
  });
  const queryChannel = useCallback(
    (params = { spaceId, currentPage: 1, pageSize: 12 }) => {
      setLoading(true);
      Requests.get('/rest/intercnn/publishChannel/pageQuery', { ...params, belongSpaceId: spaceRoleState?.belongSpaceId || '', }).then((data) => {
        if (data) {
          const { list = [], total } = data;
          setChannelData({ list, total });
          setLoading(false);
        }
      });
    },
    [spaceId],
  );

  useEffect(() => {
    if (!spaceId) {
      return;
    };
    queryChannel({ spaceId, ...paginationValue });
  }, [queryChannel, paginationValue, spaceId]);

  const refresh = () => {
    console.log('refresh');
    queryChannel({ spaceId, ...paginationValue });
  }

  return (
    <div className="global-filter-list">
      <Header />
      <Loading visible={loading}>
        {!loading ? (
          <>
            {!channelData?.list?.length ? (
              <div className="detail-container noneChannel-container">
                <img src={empty} alt="" style={{ width: '247px', height: '131px' }} />
                <h2>
                  {$i18n.get({
                    id: 'aopf.pages.channel.noneChannelTitle',
                    dm: '没有记录，请先创建应用程序',
                  })}
                </h2>
                <Button
                  type="primary"
                  onClick={() => {
                    setDrawerVisible(true);
                  }}
                  style={{ width: '118px' }}
                >
                  {$i18n.get({ id: 'aopf.pages.channel.noneChannelBtn', dm: '设置' })}
                </Button>
              </div>
            ) : (
              <AppList
                dataSource={channelData}
                callback={queryChannel}
                paginationValue={paginationValue}
                setPaginationValue={setPaginationValue}

              />
            )}
          </>
        ) : null}
      </Loading>

      <CreateDrawer
        drawerVisible={drawerVisible}
        setDrawerVisible={setDrawerVisible}
        setPaginationValue={setPaginationValue}
        onRefresh={() => refresh()}
      />
    </div>
  );
};
export default ChannelSetting;
